import { render, staticRenderFns } from "./milestones_list_section.vue?vue&type=template&id=ed774dfa&"
import script from "./milestones_list_section.vue?vue&type=script&lang=js&"
export * from "./milestones_list_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports